// Lee un token CSS (variables.css) para librerías que no aceptan var(--x), p. ej. Stripe Elements.
export const cssVar = (name, fallback = '') => {
  if (typeof window === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};
